"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiValueLabel = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = require("react-select");

var _classnames = _interopRequireDefault(require("classnames"));

var _ = require("..");

var _Dropdown = require("./Dropdown.style");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MultiValueLabel = function MultiValueLabel(props) {
  var avatarProps = props.data.avatarProps;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, avatarProps && avatarProps.src && /*#__PURE__*/_react["default"].createElement(_Dropdown.StyledChipAvatar, null, /*#__PURE__*/_react["default"].createElement(_.Avatar, (0, _extends2["default"])({
    size: 35,
    round: true
  }, avatarProps))), /*#__PURE__*/_react["default"].createElement(_Dropdown.StyledChipLabel, {
    className: (0, _classnames["default"])({
      avatar: avatarProps && avatarProps.src
    })
  }, /*#__PURE__*/_react["default"].createElement(_reactSelect.components.MultiValueLabel, props)));
};

exports.MultiValueLabel = MultiValueLabel;
MultiValueLabel.propTypes = {
  data: _propTypes["default"].shape({
    avatarProps: _propTypes["default"].object
  })
};